import * as React from 'react';
import { IData } from '../virtual-data/VirtualData';
import { FinalTableComputedColumn, FinalTableProps } from './FinalTableProps';
import { TableRowsHeights } from './utils';
import { GridCellProps } from 'react-virtualized/dist/es/Grid';
import { ReactNode, useState } from 'react';
import { FooterCell } from './FooterCell';
type Props<DATA extends IData<ID>, FILTER, ID> = {
  finalTableProps: FinalTableProps<DATA, FILTER, ID>;
  heights: TableRowsHeights;
  gridCellProps: GridCellProps;
  columnsWidth: { [key: number]: number };
  formattedColumns: FinalTableComputedColumn<DATA>[];
};

export const FooterRow = <DATA extends IData<ID>, FILTER, ID>({
  finalTableProps,
  formattedColumns,
  heights,
  gridCellProps,
  columnsWidth,
}: Props<DATA, FILTER, ID>) => {
  const cells: ReactNode[] = [];
  const [isHovered, setIsHovered] = useState(false);

  let x = 0;
  for (let colIndex = 0; colIndex < formattedColumns.length; colIndex++) {
    const cellStyle: React.CSSProperties = {
      position: 'absolute',
      height: heights.footerHeight,
      width: columnsWidth[colIndex],
      left: x,
      top: 0,
    };
    x += columnsWidth[colIndex];

    const footerGridCellProps: GridCellProps = {
      rowIndex: gridCellProps.rowIndex,
      columnIndex: colIndex,
      key: `${gridCellProps.key}_${gridCellProps.rowIndex}_${colIndex}`,
      isScrolling: false,
      isVisible: true,
      parent: gridCellProps.parent,
      style: cellStyle,
    };
    const column = formattedColumns[colIndex];
    cells.push(
      <FooterCell
        key={colIndex}
        finalTableProps={finalTableProps}
        column={column}
        gridCellProps={footerGridCellProps}
        isHovered={isHovered}
        setIsHover={(isHovered) => setIsHovered(isHovered)}
      />
    );
  }

  return (
    <div
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      {cells}
    </div>
  );
};
